import AppPage from '../../mixins/app-page'

import AppButton from '../app-button'
import AppCountdown from '../app-countdown'
import AppNewsletter from '../app-newsletter'
import AppProceedsGraphic from '../app-proceeds-graphic'
import AppTokenAllocationGraphic from '../app-token-allocation-graphic'

import SimpleGridExperience from '../../libs/experience/SimpleGridExperience'

export default
{
    name: 'page-presale',

    mixins: [
        AppPage
    ],

    components: {
        AppButton,
        AppCountdown,
        AppNewsletter,
        AppProceedsGraphic,
        AppTokenAllocationGraphic
    },

    data() {
        return {
            maximumListItems: [
                [{
                    title: 'Pre-Sale',
                    content: 'Our pre-sale will run from September 10th – October 15th and will only be available to accredited investors We will be accepting debt-based financing from participants who will accrue interest and be repaid monthly over a period of 12 months with PRAX at a price equal to 30% less than that outlined for our token generation event.'
                }, {
                    title: 'Token Generation Event',
                    content: 'Of the total allocation, 15M tokens will be allocated to a sale that marks the launch of the network. The initial sale is necessary to ensure that the circulating supply meets platform user demand for additional platforms and rapid growth following the sale.'
                }, {
                    title: 'Daily Sales',
                    content: 'Platform users can purchase additional PRAX at any time directly through our smart contract. 21 million locked tokens will be allocated to artificially inflate the daily sale contract with inflation halving periods every four years. Our platform’s PRAX recycling mechanism will resupply our daily sale every 10 minutes.'
                }],
                [{
                    title: 'Reward Engine',
                    content: 'Tokens available in the Reward Engine will be stored in a hot wallet system to limit damage in case of vulnerability. Rewards can initially be earned through Spatial Mining and will be split between any parties involved.'
                }, {
                    title: 'Strategic Reserve',
                    content: 'The strategic reserve may be used in further sales by Practical, or amounts may be moved at the discretion of the Board of Directors. For example, PRAX held in the strategic reserve may be transferred to the reward engine, internal projects, external projects, or long-term company incentive plans.'
                }, {
                    title: 'Practical Team, Advisors, Partners',
                    content: 'This percentage covers allocations to the Practical team, its advisors, and strategic partners. Details surrounding team token availability will be published.'
                }]
            ],
            tokenAllocationItems: [{
                label: 'Token Generation Event',
                percent: 15,
                id: 0
            }, {
                label: 'Pre-Sale',
                percent: 4,
                id: 1
            }, {
                label: 'Daily Sales',
                percent: 21,
                id: 2
            }, {
                label: 'Reward Engine',
                percent: 20,
                id: 3
            }, {
                label: 'Strategic Reserve',
                percent: 20,
                id: 4
            }, {
                label: 'Practical Team, Advisors, Partners',
                percent: 20,
                id: 5
            }],
            proceedsItems: [{
                label: 'Foundation',
                percent: 1
            }, {
                label: 'Legal',
                percent: 6
            }, {
                label: 'Discretionary',
                percent: 12
            }, {
                label: 'Organization',
                percent: 15
            }, {
                label: 'Outreach',
                percent: 16
            }, {
                label: 'Technology',
                percent: 50
            }]
        }
    },

    created() {

    },

    mounted() {
        this.$background = document.querySelector('.js-background')
        this.experience = new SimpleGridExperience()
        this.experience.renderer.domElement.classList.add('p-presale__experience')
        this.experience.renderer.domElement.classList.add('u-absolute')
        this.experience.renderer.domElement.classList.add('u-pos-tl')

        this.$background.appendChild(this.experience.renderer.domElement)
    },

    destroyed() {
        this.$background.removeChild(this.experience.renderer.domElement)
        this.experience.dispose()
    },

    methods: {
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-presale/script.js